/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiServices } from "@/services/api.services";
import { formatErrorDetails, setFormError } from "@/services/error.services";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useToast } from "@/hooks/use-toast";
import { setToken } from "@/lib/token";
import { useNavigate } from "react-router-dom";
import { GLOBAL_MESSAGES } from "@/lib/global-message";
import { DEFAULT_ROUTE } from "@/lib/static";

export const useForgotPassword = () => {
  //Encryption Method for password
  const { toast } = useToast();
  const navigate = useNavigate();

  const formSchema = z.object({
    username: z.string().min(1, {
      message: "Username is required",
    }),
  });

  type LoginFormValues = z.infer<typeof formSchema>;

  const form = useForm<LoginFormValues>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      username: "",
    },
  });

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { error }: any = await login(values);
    setFormError(error, form.setError);
  }

  const login = async (prop: any) => {
    const payload = {
      company_id: "admin",
      //"company_id": "",
      username: "system",
      data: {
        email: prop.username,
      },
    };

    console.log({ payload });

    const { data, /* , statusCode, message, */ message, error } =
      await apiServices<any>("/password/forgot", "post", payload);

    console.log({ data, error, message });

    if (error) {
      const formatedError = formatErrorDetails(error);
      toast({
        title: "Login Failed",
        description: error?.status?.msg || message,
        variant: "destructive",
      });
      return { error: formatedError };
    }

    if ((data as any)?.access_token) {
      setToken(data?.access_token);
      toast({
        description: GLOBAL_MESSAGES.LOGIN_DATA.SUCCESS,
        variant: "success",
      });
      navigate(DEFAULT_ROUTE);
    }

    return {};
  };

  return { login, onSubmit, form };
};
